"use strict";

import * as React from 'react';
export const LocaleDirContext = /*#__PURE__*/React.createContext('ltr');
LocaleDirContext.displayName = 'LocaleDirContext';
//# sourceMappingURL=LocaleDirContext.js.map